import React from "react";
import "./Our_Associates.css";
import Common_Title from "../../common_components/common_title/Common_Title";

const Our_Associates = () => {
  const data = [
    "/assets/images/home/associates/img1.png",
    "/assets/images/home/associates/img2.png",
    "/assets/images/home/associates/img3.png",
    "/assets/images/home/associates/img4.png",
    "/assets/images/home/associates/img5.png",
    "/assets/images/home/associates/img6.png",
  ];

  return (
    <section className="Our_Associates">
      <div className="container">
        <div className="content_div">
          <div className="title_holder">
            <Common_Title simpleText="Our" darkText="Associates" />
          </div>

          <div className="data_holder">
            <div className="row">
              {data?.map((item) => {
                return (
                  <div className="col-lg-2 col-md-3 col-sm-4 col-6 mb-4">
                    <div className="img_holder">
                      <img
                        src={process.env.PUBLIC_URL + item}
                        className="logo_img"
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Our_Associates;
